import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, type Ref, toRefs } from 'vue';
import { Event, type EventMetadata } from '@/models/Event';
import { apiUrl, globalParam } from '@/helpers/globals';
import { instance as api } from '@/helpers/api';
import dayjs from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'MetadataPanel',
  props: {
    record: null
  },
  setup(__props: any) {

const props = __props as {
    record: Event;
};


const { record } = toRefs(props);

const additionalMetadata: Ref<EventMetadata | null> = ref(null);

const legalInfo = computed(() => {
    if (additionalMetadata.value?.legalAcceptances?.length) {
        return additionalMetadata.value.legalAcceptances.map((entry) => {
            return {
                user: entry.user,
                acceptanceType: entry.acceptanceType,
                date: dayjs(entry.timestamp),
            };
        });
    } else {
        return null;
    }
});

const hideFrontendLink = computed(() => {
    return globalParam('event.hide_frontend_links');
});

const loadAdditionalMetadata = async () => {
    try {
        const ret = await api().get('/Event/loadMetadata', {
            params: { id: record.value.id },
        });
        if (ret?.data) {
            additionalMetadata.value = ret.data;
        }
    } catch (e) {
        // pass
    }
};

onMounted(() => {
    loadAdditionalMetadata();
});

return { __sfc: true,props, record, additionalMetadata, legalInfo, hideFrontendLink, loadAdditionalMetadata, apiUrl }
}

})